import * as React from 'react';

import { ISalesLink } from '../../types/offersData';
import { SalesLink } from './components/SalesLink';

import * as styles from './SalesLinks.css';

interface ISalesLinksProps {
  links: ISalesLink[];
  onLinkClick(link: ISalesLink): void;
}

export function SalesLinks({ links, onLinkClick }: ISalesLinksProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['links']}>
        {links.map((link, index) => (
          <SalesLink key={index} link={link} onClick={onLinkClick} />
        ))}
      </div>
    </div>
  );
}
